'use client';
import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState, useRef, useEffect } from 'react';
import { FavoriteIcon, CheckmarkBackgroundIcon } from '@paypalcorp/pp-react-icons';
import { cx, KeyboardCode } from '@paypalcorp/pp-react-utils';
import * as styles from './styles.css';
export { styles as toastStyles };

var _excluded = ["message", "id", "isSuccess", "type", "duration", "onClose", "direction", "className", "containerClassName"];
var toastTypes = ['info', 'success', 'favorite'];
var defaultDuration = 7000;
var Toast = function (_ref) {
  var _ref$message = _ref.message,
    message = _ref$message === void 0 ? 'message' : _ref$message,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'Toast' : _ref$id,
    _ref$isSuccess = _ref.isSuccess,
    isSuccess = _ref$isSuccess === void 0 ? false : _ref$isSuccess,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? defaultDuration : _ref$duration,
    onClose = _ref.onClose,
    direction = _ref.direction,
    className = _ref.className,
    containerClassName = _ref.containerClassName,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    showState = _useState2[0],
    setShowState = _useState2[1];
  var startY = null;
  var startX = null;
  var toastRef = useRef();
  var getWrapperCurrent = function (w) {
    return w && w.current ? w.current : null;
  };
  var autoHideTimer = getWrapperCurrent(useRef());
  var handleClose = function () {
    setShowState(0);
    clearTimeout(autoHideTimer);
    startX = null;
    startY = null;
  };
  var handleKey = function (evt) {
    if (new KeyboardCode(evt.key || evt.keyCode).IS_ESC) {
      handleClose();
    }
  };

  /* istanbul ignore next */
  var handleTouchStart = function (evt) {
    // prevent from scrolling
    evt.preventDefault();

    /* istanbul ignore next */
    if (!startY && !startX) {
      var firstTouch = evt.changedTouches[0];
      startY = firstTouch.pageY;
      startX = firstTouch.pageX;
    }
  };

  /* istanbul ignore next */
  var handleTouchEnd = function (evt) {
    var endTouch = evt.changedTouches[0];
    var xDiff = startX - endTouch.pageX;
    var yDiff = startY - endTouch.pageY;
    if (Math.abs(yDiff) > Math.abs(xDiff)) {
      // means up/down is most significant
      if (yDiff > 0) {
        // swipe up
        handleClose();
      }
    }
    startX = null;
    startY = null;
  };
  useEffect(function () {
    if (showState < 0) {
      setShowState(1);
    }
    document.addEventListener('keydown', handleKey);
    var toast = getWrapperCurrent(toastRef);
    // Adding native event since evt.preventDefault (for preventing from scrolling
    // while swiping on toast up) is not possible using synthetic event
    //eslint-disable-next-line no-unused-expressions
    toast === null || toast === void 0 ? void 0 : toast.addEventListener('touchstart', handleTouchStart);
    return function () {
      document.removeEventListener('keydown', handleKey);
      //eslint-disable-next-line no-unused-expressions
      toast === null || toast === void 0 ? void 0 : toast.removeEventListener('touchstart', handleTouchStart);
      clearTimeout(autoHideTimer);
    };
  }, [showState]);

  /* istanbul ignore next */

  var containerClasses = cx(styles.container, showState && styles.show, !showState && styles.hide, containerClassName);
  var selectedToastType = toastTypes.includes(type) ? type : 'info';

  // By this condition, `isSuccess` gets more priority than `type`. This should force user to remove this deprecated prop.
  // TODO: remove this code block after removing the deprecated prop.
  if (isSuccess) {
    selectedToastType = 'success';
  }
  var showToastIcon = function () {
    var icon = null;
    if (selectedToastType === 'favorite') {
      icon = /*#__PURE__*/React.createElement(FavoriteIcon, {
        className: styles.toastIcon,
        size: "sm",
        "data-ppui": "true"
      });
    } else if (selectedToastType === 'success') {
      icon = /*#__PURE__*/React.createElement(CheckmarkBackgroundIcon, {
        className: styles.toastIcon,
        size: "sm",
        "data-ppui": "true"
      });
    }
    return icon;
  };
  var toastClassses = cx(styles.base, styles.toastType[selectedToastType], className);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    dir: direction,
    className: containerClasses,
    "aria-hidden": showState <= 0,
    role: "alert",
    onAnimationEnd: function onAnimatonEnd() {
      if (showState === 1) {
        var timeOut = duration > defaultDuration ? duration : defaultDuration;
        autoHideTimer = setTimeout(handleClose, timeOut);
      } else if (typeof onClose === 'function') {
        onClose();
      }
    },
    "data-ppui-info": "toast_4.2.3__8.12.0"
  }, rest), /*#__PURE__*/React.createElement("div", {
    ref: toastRef,
    className: toastClassses,
    onTouchEnd: handleTouchEnd,
    "data-ppui": "true"
  }, showToastIcon(), /*#__PURE__*/React.createElement("span", {
    className: styles.message,
    "data-ppui": "true"
  }, message)));
};

export { Toast };
